module.exports = __webpack_public_path__ + "img/header-memoireRingsBudgetLow@2x.077464f.jpg";